<template>
    <LayoutFooterPhoneService
        v-if="content?.config?.phoneServiceTitle?.value?.trim() && content?.config?.phoneServicePhonenumber?.value?.trim()"
        :title="content?.config?.phoneServiceTitle?.value"
        :text="content?.config?.phoneServiceText?.value"
        :phone-number="content?.config?.phoneServicePhonenumber?.value"
        :opening-hours="content?.config?.phoneServiceOpeningHours?.value"
        :images="mappedPhoneServiceImages"
    />
    <LayoutFooter :data="content?.config" :media="content?.data" />
</template>

<script setup lang="ts">
import type { HblSlot } from '@/utils/types'
import { hblMapMedia } from '#imports'

const props = defineProps<{
    content: HblSlot
}>()

const mappedPhoneServiceImages = computed(() => {
    const data = props.content?.data as any
    return data?.phoneServiceImages?.map((img: any) => ({
        mediaId: img.mediaId,
        mediaUrl: img.mediaUrl,
        media: img.media ? hblMapMedia(img.media) : undefined
    }))
})
</script>